/**
 * Component   : CreateRole
 * Description : Adding a new role
 */
import { Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, handleApiError, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { HeaderList, IHeaderListActions } from "../../Components/Header/HeaderList";
import WSTreeViewField from "../../Components/Roles/TreeView";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
export const CreateRole: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, watch, reset, getValues } = useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const params = useParams();
    const [defaultRoles, setDefaultRoles] = useState<any>([]);
    const [permissions, setPermissions] = useState<any>([]);
    const id = params?.id;
    useEffect(() => {
        updateMainHeader("Add Role");
        breadCrumbsStore.updateBreadCrumbs([
            { "Roles": "/role/list" },
            { [id ? 'Edit Role' : "Create Role"]: `` },
        ]);
    });
    useEffect(() => () => {
        reset()
    }, [])
    useEffect(() => {
        /**
         * Method to get the user record by id for edit purpose
         * @param id 
         */
        async function getDefaultRole(): Promise<void> {
            try {
                const response: any = await callAPI('user-roles/default-role', Method.GET, null, null);
                setDefaultRoles(response?.permissions || [])
            } catch (error) {
                showMessage('Error fetching Role:', 'error');
            }
        }
        if (!id) {
            getDefaultRole();
        }
    }, []);
    useEffect(() => {
        /**
         * Method to get the user record by id for edit purpose
         * @param id 
         */
        async function getRole(): Promise<void> {
            try {
                const response: any = await callAPI('user-roles/get-role-permissions', Method.GET, null, id);
                setDefaultRoles(response?.permissions || [])
                setValue('roleName', response?.roleName)
            } catch (error) {
                showMessage('Error fetching Role:', 'error');
            }
        }
        if (id) {
            getRole();
        }
    }, [id]);
    const handleCancelClick = () => {
        navigate("/role/list");
    };

    /**
     * Method for Add/Update the data
     * @param data 
     */
    const onSubmit = async (data: any) => {
        try {
            setLoading(true)
            const request: any = await setRequest(data);
            if (id) {
                const response: any = await callAPI(`user-roles`, Method.PUT, request, id);
                if (response?.errors) {
                    const mess = handleApiError(response)
                    showMessage(mess, 'error');
                }
                else if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/role/list");
                }
            } else {
                const response: any = await callAPI('/user-roles/create', Method.POST, request);
                if (response?.errors) {
                    const mess = handleApiError(response)
                    showMessage(mess, 'error');
                }
                else if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/role/list");
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        }
        finally {
            setLoading(false)
        }
    };

    /**
     * Method to set the request for the user
     * @param data 
     * @returns 
     */
    async function setRequest(data: any) {

        if (permissions?.length > 0) {
            permissions.forEach((permission: any) => {
                delete permission.selectAll;
            });
        }
        let request: any = {
            roleName: data?.roleName,
            permissions: permissions?.length > 0 ? permissions : defaultRoles
        };
        return request;
    }
    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save', loading: loading, size: 'small', buttonType: 'submit', variant: 'outlined', color: 'primary' }
        ]
    const handleChangeDaa = (data: any) => {
        setPermissions(data);
    }
    return (

        <>   <form onSubmit={handleSubmit(onSubmit)}>
            <HeaderList title={!id ? "Add Role" : "Update Role"} isBackButton={true} url="/role/list" type="card" actions={actions} isDivider headerSx={{ height: 50 }} />
            <Paper elevation={3} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, border: '1px solid #ccc', borderRadius: '8px' }}>
                <Grid xs={12} className="modal-input" container spacing={2} style={{ marginTop: 10 }}>
                    <Grid item sm={12} xs={12}>
                        <Typography sx={{ fontSize: '.9rem' }} color={'gray'}>Role Information</Typography>
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <WSTextField control={control} id="roleName" {...register('roleName')} name="roleName" rules={{ required: true }} label="First Name *"></WSTextField>
                    </Grid>
                </Grid>
                <Grid item sm={12} sx={{ marginTop: 2 }}>
                    {defaultRoles && defaultRoles.length > 0 && <WSTreeViewField getValues={getValues} setValue={setValue} control={control} onCheckedChange={handleChangeDaa} permissions={defaultRoles} />}
                </Grid>


            </Paper>
        </form>
        </>
    );
});
